<template>
    <div class="trophy">
        <div class="inner">
            <div class="text">恭喜獲得道具</div>
            <div class="item">
                <img
                    :src="
                        require(`@/assets/Stage/Tower/${type}/Level${level}/${index}.png`)
                    "
                    alt=""
                    width="100%"
                />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        index: Number,
    },
    computed: {
        type() {
            return (
                this.$route.params.type.charAt(0).toUpperCase()
                + this.$route.params.type.slice(1)
            );
        },
        level() {
            return (
                this.$route.params.level.charAt(0).toUpperCase()
                + this.$route.params.level.slice(1)
            );
        },
    },
};
</script>

<style lang="scss" scoped>
.trophy {
    margin-bottom: 20px;
    width: 80%;
    display: flex;
    justify-content: center;
    .inner {
        color: #4683bc;
        font-weight: bold;
        font-size: 1.2em;
        width: 48%;
        display: flex;
        flex-direction: column;
        align-items: center;
        .item {
            color: #003a5d;
            margin-top: 10px;
            width: 100%;
            border-radius: 30.1px;
            background-color: #fff;
            box-shadow: 0 2px 11px 0 rgba(0, 152, 201, 0.37);
            text-align: center;
        }
    }
}
</style>
